/** VBS Mexico storefront copy — es-MX only (tenant key: mx). */
export const MX_STOREFRONT_COPY = {
  "es-MX": {
    common: {
      brandFallback: "Valve Body Specialties MX",
      headerTagline: "Remanufactura de precisión",
      catalog: "Productos",
      cart: "Carrito",
      checkout: "Pago",
      searchPlaceholder: "Buscar cuerpos de válvulas...",
      browseCatalog: "Ver catálogo",
      signIn: "Iniciar sesión",
      account: "Mi cuenta",
      portal: "Portal",
      signOut: "Cerrar sesión",
      loading: "Cargando...",
      footerRights: "Todos los derechos reservados.",
      home: "Inicio",
      register: "Registro",
      utilityStrip: "Cuerpos de válvulas · Cores · Soporte de garantía",
      footerBlurb:
        "Cuerpos de válvulas remanufacturados para talleres de transmisión — medidos, calibrados y respaldados con registro de garantía en su portal.",
      shopSection: "TIENDA",
      legalSection: "LEGAL",
      privacy: "Privacidad",
      deleteAccount: "Eliminar cuenta",
      menu: "Menú",
      add: "Agregar",
      details: "Detalles →",
      skuTbd: "SKU pendiente",
      requestQuote: "Solicitar cotización",
      loadingInventory: "Cargando inventario…",
      listingCount: "{count} artículo(s)",
      loadingCatalog: "Cargando catálogo…",
      allTransmissions: "Todas las transmisiones",
      productCatalog: "Catálogo de productos",
    },
    home: {
      eyebrow: "Cuerpos de válvulas remanufacturados premium",
      heroTitle: "Los cambios controlados comienzan con hidráulica precisa.",
      heroSubtitle:
        "Cuerpos de válvulas reconstruidos con corrección de desgaste medida, calibración precisa y un flujo de trabajo diseñado para resultados repetibles.",
      primaryCta: "Ver productos",
      secondaryCta: "Iniciar sesión",
      myAccount: "Mi cuenta",
      openAccount: "Abrir cuenta",
      goToPortal: "Ir al portal",
      createAccount: "Crear cuenta",
      trustQc: "Calibración documentada en cada unidad",
      trustCore: "Programa de devolución de cores con seguimiento claro",
      trustWarranty: "Registre cuerpos de válvulas en su portal",
      trustSupport: "Asistencia técnica directa para talleres",
      trustStatQc: "Calidad",
      trustStatCore: "Core",
      trustStatWarranty: "Garantía",
      trustStatSupport: "Soporte",
      featuredEyebrow: "En stock y listos",
      featuredTitle: "Cuerpos de válvulas",
      featuredLink: "Catálogo completo",
      loadingProducts: "Cargando productos…",
      ctaBandTitle: "Hecho para talleres de transmisión",
      ctaBandBody:
        "Ordene refacciones, registre unidades, administre cores y abra reclamos de garantía — todo desde una sola cuenta.",
      contactEyebrow: "¿Dudas?",
      contactTitle: "Llámenos si tiene preguntas",
      contactBody:
        "Nuestro equipo en México está listo para ayudarle con pedidos, cores y soporte técnico.",
      callUs: "Llamar",
      whatsappUs: "WhatsApp",
    },
    catalog: {
      title: "Encuentre el cuerpo de válvulas correcto.",
      subtitle: "Busque cuerpos de válvulas disponibles con precios actuales.",
      empty: "Ningún producto coincide con su búsqueda.",
      emptyTitle: "No se encontraron productos",
      emptyText: "Intente ajustar su búsqueda o filtros.",
      productStatusFallback: "Artículo de catálogo",
      skuPrefix: "SKU",
      priceQuote: "Cotización",
      addToCart: "Agregar al carrito",
      addedToCart: "Agregado al carrito",
      inCart: "En carrito",
    },
    product: {
      backToCatalog: "Volver al catálogo",
      backToProducts: "Volver a productos",
      details: "Detalles",
      unitDetails: "Detalles de la unidad",
      specifications: "Especificaciones",
      installationNotes: "Notas de instalación",
      technicalDetails: "Detalles del producto",
      fitmentYears: "Aplicación",
      addToCart: "Agregar al carrito",
      checkout: "Pagar",
      alreadyInCart: "en el carrito",
      coreCharge: "Depósito de core",
      productFallback: "Producto",
      signInToOrder: "Inicie sesión para ordenar",
      buyNow: "Comprar ahora",
      unitPrice: "Precio unitario",
      coreDeposit: "depósito de core (reembolsable)",
      contactPricing: "Contáctenos para cotizar este artículo.",
      loadingProduct: "Cargando producto…",
      notFound: "Producto no encontrado",
      addedNotice: "{count} agregado(s) al carrito",
    },
    cart: {
      title: "Carrito",
      emptyTitle: "Su carrito está vacío",
      emptyText: "Agregue productos del catálogo para iniciar un pedido.",
      total: "Total del carrito",
      checkout: "Pagar",
      signInRequired: "El pago requiere iniciar sesión con una cuenta de cliente.",
      refundableDeposit: "El depósito es reembolsable después de la devolución y aprobación.",
    },
    checkout: {
      title: "Pago",
      shipping: "Envío",
      payment: "Pago",
      placeOrder: "Realizar pedido",
      needInvoice: "¿Necesita datos de facturación?",
      requiredFields: "Faltan campos obligatorios.",
    },
    auth: {
      signInTitle: "Iniciar sesión",
      registerTitle: "Crear cuenta",
      customerAccount: "Cuenta de cliente",
      distributorAccount: "Cuenta de distribuidor",
      email: "Correo electrónico",
      password: "Contraseña",
    },
    portal: {
      customerPortal: "Portal de clientes",
      distributorPortal: "Portal de distribuidores",
      accountTools: "Herramientas de cuenta",
      distributorTools: "Herramientas de distribuidor",
      accountToolsDescription:
        "Pedidos, cuerpos de válvulas, perfil, facturas y direcciones.",
      distributorToolsDescription:
        "Pedidos, unidades vendidas, perfil y direcciones.",
      accountHome: "Cuenta",
      registeredUnits: "Cuerpos de válvulas",
      coreReturns: "Devolución de cores",
      returnCore: "Devolver core",
      orders: "Pedidos",
      profile: "Perfil",
      profileBilling: "Perfil / Facturación",
      addresses: "Direcciones",
      deleteAccount: "Eliminar cuenta",
      browseCatalog: "Ver catálogo",
      ordersAndService: "Pedidos y servicio",
      ordersHint: "Estado, totales, facturas y rastreo.",
      profileHint: "Contacto e información de cuenta.",
      addressesHint: "Direcciones de envío guardadas.",
      support: "Soporte",
      supportHint: "Chat con VBS — mensajes y fotos.",
      customer: "Cliente",
      distributor: "Distribuidor",
      linkedCustomers: "Clientes vinculados",
      linkedCustomersDetail: "Clientes asignados a su cuenta.",
      distributorRequests: "Solicitudes de pedido",
      distributorRequestsDetail: "Apruebe solicitudes o envíelas a VBS.",
    },
    registeredUnits: {
      title: "Cuerpos de válvulas",
      subtitle: "Registre unidades vendidas, devuelva cores e inicie reclamos de garantía.",
      distributorSubtitle:
        "Rastree unidades vendidas por distribuidor y estado de registro.",
      fallbackName: "Cuerpo de válvulas",
      open: "Abrir cuerpos de válvulas",
      scanTitle: "Escanear",
      loadError: "No se pudieron cargar los cuerpos de válvulas.",
      loading: "Cargando cuerpos de válvulas…",
      distributorEmpty: "Aún no se encontraron unidades asignadas al distribuidor.",
      empty: "Aún no se encontraron cuerpos de válvulas registrados o vendidos directamente.",
      notFound: "Cuerpo de válvulas no encontrado.",
    },
    coreReturn: {
      title: "Devolver core",
      subtitle: "Envíe una solicitud de devolución para este artículo.",
      hubTitle: "Devolución de cores",
      hubSubtitle:
        "Devuelva cores adeudados con una etiqueta prepaga en tres pasos.",
      wizardSubtitle: "Confirme, empaque y luego imprima su etiqueta prepaga.",
      refundText:
        "Devuelva su core reconstruible. Cuando VBS lo reciba, inspeccione y apruebe, este monto se reembolsará.",
      sealedLabel: "El cuerpo de válvulas está sellado en la bolsa de plástico incluida.",
      instructions: {
        oilTitle: "Drene todo el aceite",
        oilBody:
          "Drene el core por completo. Limpie residuos para que la caja no gotee ni filtre aceite.",
        bagTitle: "Séllelo en una bolsa de plástico",
        bagBody:
          "Coloque el core en la bolsa de plástico incluida y séllela antes de empacarlo.",
        boxTitle: "Use la caja original",
        boxBody:
          "Empaque el core embolsado en la caja original o anterior para un envío seguro.",
      },
    },
    warranty: {
      title: "Garantía",
      subtitle: "Inicie y dé seguimiento a reclamos de garantía.",
      activeClaim: "Ya hay un reclamo activo abierto.",
      returnShipping: "Envío de devolución (pagado por VBS)",
      inspectionUpdates:
        "Las actualizaciones de inspección aparecen aquí cuando VBS reciba la unidad devuelta.",
    },
    support: {
      title: "Soporte",
      subtitle: "Escriba a soporte VBS, comparta fotos y dé seguimiento a sus conversaciones.",
      staffName: "Soporte VBS",
      you: "Usted",
    },
    legal: {
      privacyTitle: "Aviso de privacidad",
      deleteTitle: "Eliminar cuenta",
      privacyIntro:
        "Este aviso explica cómo Valve Body Specialties recopila, usa, comparte y protege la información de sus clientes.",
      deleteIntro:
        "Puede solicitar la eliminación de su cuenta de cliente o distribuidor desde el portal de cuenta.",
      appInstruction:
        "Inicie sesión en su cuenta de cliente o distribuidor.",
      verificationText:
        "Podemos contactarle desde un correo oficial de VBS si se requiere verificación adicional.",
    },
  },
};
